// src/slices/branchSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_URL } from '../../utils/constant';

// Async thunks for Branch CRUD operations
export const fetchBranches = createAsyncThunk('branches/fetchBranches', async () => {
  const response = await axios.get(`${API_URL}/branches`);
  return response.data;
});

export const createBranch = createAsyncThunk('branches/createBranch', async (branchData) => {
  const response = await axios.post(`${API_URL}/branches`, branchData);
  return response.data;
});

export const updateBranch = createAsyncThunk('branches/updateBranch', async ({ id, branchData }) => {
  const response = await axios.put(`${API_URL}/branches/${id}`, branchData);
  return response.data;
});

export const deleteBranch = createAsyncThunk('branches/deleteBranch', async (id) => {
  await axios.delete(`${API_URL}/branches/${id}`);
  return id;
});

// Initial state
const initialState = {
  branches: [],
  loading: false,
  error: null,
};

// Branch slice
const branchSlice = createSlice({
  name: 'branches',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch branches
      .addCase(fetchBranches.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBranches.fulfilled, (state, action) => {
        state.loading = false;
        state.branches = action.payload;
      })
      .addCase(fetchBranches.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Create branch
      .addCase(createBranch.fulfilled, (state, action) => {
        state.branches.push(action.payload);
      })

      // Update branch
      .addCase(updateBranch.fulfilled, (state, action) => {
        const index = state.branches.findIndex((branch) => branch.id === action.payload.id);
        if (index !== -1) {
          state.branches[index] = action.payload;
        }
      })

      // Delete branch
      .addCase(deleteBranch.fulfilled, (state, action) => {
        state.branches = state.branches.filter((branch) => branch.id !== action.payload);
      });
  },
});

export default branchSlice.reducer;
